import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const URL = environment.url_calculadora;

@Injectable({
  providedIn: 'root'
})


export class CalculadoraService {
  

  constructor(
    private http : HttpClient
  ) { }

    getData(request : RequestCalculadora){
      
      return this.http.post<RespuestaCalculadora>(URL,request);

    }

}
